import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import t from 'typy';
import { InboxIcon } from '@heroicons/react/24/solid';
import {
  capitalizeFirstLetter,
  firstLetter,
  getFirstNonZeroValue,
} from '../../utils';

const NotificationDropdown = ({ unReadNotifications }) => {
  return (
    <>
      <div className="block px-4 py-2 font-medium text-center text-gray-700 rounded-t-lg bg-gray-50">
        Notifications
      </div>
      <div className="divide-y divide-gray-100">
        {t(unReadNotifications).isNullOrUndefined ||
        t(unReadNotifications).isEmptyArray ? (
          <div className="flex flex-col items-center justify-center h-[25rem]">
            <InboxIcon className="w-10 h-10 mb-1 text-gray-500" />
            <p className="text-sm">Notifications not found.</p>
          </div>
        ) : (
          unReadNotifications?.map((unreadNotification) => (
            <Link
              to="/dashboard"
              className="flex px-4 py-3 hover:bg-gray-100"
              key={unreadNotification?._id}
            >
              <div className="flex-shrink-0">
                {t(unreadNotification?.user?.profile_pic).isNullOrUndefined ||
                unreadNotification?.user?.profile_pic === '' ? (
                  <div className="relative inline-flex items-center justify-center overflow-hidden bg-gray-100 rounded-full w-11 h-11">
                    <span className="text-sm font-semibold text-gray-600">
                      {firstLetter(
                        unreadNotification?.user?.full_name,
                      ).toUpperCase()}
                    </span>
                  </div>
                ) : (
                  <img
                    className="rounded-full w-11 h-11"
                    src={unreadNotification?.user?.profile_pic}
                    loading="lazy"
                    alt="Jese"
                  />
                )}
              </div>
              <div className="w-full pl-3">
                <div className="font-semibold text-gray-900">
                  {capitalizeFirstLetter(unreadNotification?.title)}{' '}
                </div>
                <div className="text-gray-500 text-sm mb-1.5">
                  {unreadNotification?.message} from{' '}
                  <span className="font-medium text-gray-900">
                    {capitalizeFirstLetter(unreadNotification?.user?.full_name)}{' '}
                  </span>
                </div>
                <div className="text-xs text-blue-600">
                  {getFirstNonZeroValue(
                    DateTime.fromISO(unreadNotification?.createdAt),
                  )}
                </div>
              </div>
            </Link>
          ))
        )}
      </div>
    </>
  );
};

NotificationDropdown.defaultProps = {
  unReadNotifications: null,
};

NotificationDropdown.propTypes = {
  unReadNotifications: PropTypes.oneOfType([PropTypes.any]),
};

export default NotificationDropdown;
